import { Layout, Row, Col, Typography, Button, Divider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FacebookFilled, LinkedinFilled, InstagramFilled } from "@ant-design/icons";
import "../../styles/Footer.css";
import { useTenantContext } from "../../utils/Context/TenantsContext";

const { Footer } = Layout;
const { Text } = Typography;

export default function FooterLayout() {
  const tenant = useTenantContext();

  return (
    <Footer
      style={{
        background: "#003049",
        color: "#fff",
        padding: "2rem 10%",
        justifyContent: "center",
        textAlign: "justify",
        marginTop: "0",
      }}
    >
      <div className="footer_main_container">
        <img src={tenant?.footerLogo} alt="fw_logo" className="footer_logo" />
        <Text className="footer_text">TALK TO US</Text>
        <Row gutter={[16, 16]}>
          <a
            href={
              tenant?.supportEmail ? `mailto:${tenant.supportEmail}` : undefined
            }
            style={{ display: "block", color: "#d9d9d9" }}
          >
            <Col>
              <FontAwesomeIcon icon={faEnvelope} /> {tenant?.supportEmail}
            </Col>
          </a>
        </Row>
        <Row>
          <Col>
            <a
              href={tenant?.socialMedia?.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                icon={<InstagramFilled />}
                shape="circle"
                style={{
                  marginRight: "10px",
                  border: "1px solid",
                  backgroundColor: "#003049",
                  color: "white",
                }}
              />
            </a>
            <a
              href={tenant?.socialMedia?.linkedin}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                icon={<LinkedinFilled />}
                shape="circle"
                style={{
                  marginRight: "10px",
                  border: "1px solid",
                  backgroundColor: "#003049",
                  color: "white",
                }}
              />
            </a>
            <a
              href={tenant?.socialMedia?.facebook}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                icon={<FacebookFilled />}
                shape="circle"
                style={{
                  border: "1px solid",
                  backgroundColor: "#003049",
                  color: "white",
                }}
              />
            </a>
          </Col>
        </Row>
        <Divider style={{ borderColor: "#0d4666", margin: "10px 0" }} />
        <Row>
          <Col>
            <Text
              style={{
                color: "#d9d9d9",
                fontFamily: "Roboto,sans-serif",
                fontWeight: 400,
              }}
            >
              © {new Date().getFullYear()} All Rights Reserved. © {tenant?.fullName}
            </Text>
          </Col>
        </Row>
      </div>
    </Footer>
  );
}
